var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("iframe", {
    ref: "viewerIframe",
    staticStyle: { width: "100%", height: "100%", border: "0 none" },
    attrs: { src: _vm.viewerUrl },
    on: { load: _vm.handleIframeLoadEvent },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }